import { overviewContentMap } from './configuration/overview_config'

export function getOverviewHelpCenterLink(contentKey) {
  return overviewContentMap[contentKey]?.helpCenterLink
}
